import React from 'react';
import Revealr_Yellow from '../../assets/images/Revealr_Yellow.png';
import Revealr_WhiteText from '../../assets/images/Revealr_WhiteText.png';
import './style.scoped.scss';

const PoweredBy = ({ isDocument, showLogo }) => {
  return (
    <div className={`powered${isDocument && !showLogo ? ' document-page' : ''}`}>
      <span>Powered by</span>
      <a href="https://revealr.ai/" target="_blank" rel="noreferrer">
        <img
          className="powered__logo"
          alt="logo"
          src={isDocument ? Revealr_WhiteText : Revealr_Yellow}
        />
      </a>
    </div>
  )
};

export default PoweredBy;
